import axios from 'axios'
import envVariableService from '../services/envVariableService'
import loginService from '../services/loginService'

const instance = axios.create({
  baseURL: envVariableService.redditLikeApiBaseUrl
})

instance.interceptors.response.use(res => {
  return res.data
})

instance.interceptors.request.use(req => {
  const token = loginService.getToken()
  req.headers.Authorization = `Bearer ${token}`
  return req
})

export default instance
